"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getE164Parts = void 0;
/**
 * Extract the E164 parts from a phone number
 * @public
 *
 * @param phone - An unformatted 12-digit phone number string
 *
 * @returns phone number parts if phone is valid, otherwise empty array
 *
 *
 * @example
 * ```ts
 * cont result = getE164Parts('+12125559656');
 * console.log(result);
 * // -> ['212', '555', '9656']
 * ```
 */
function getE164Parts(phone) {
    if (phone.length === 12) {
        return [
            phone.substring(2, 5),
            phone.substring(5, 8),
            phone.substring(8, 12),
        ];
    }
    return [];
}
exports.getE164Parts = getE164Parts;
//# sourceMappingURL=get-E164-parts.js.map